import { create } from "zustand"
import type { UserRow } from "interfaces/index"

type SelectedRow = Partial<UserRow> & Record<string, unknown>

interface UserManagementState {
    paginationToken: string
    setPaginationToken: (paginationToken: string) => void
    isActive: boolean
    setIsActive: (isActive: boolean) => void
    addOriRfpGroups: Function
    setAddOriRfpGroups: (addOriRfpGroups: Function) => void
    removeOriRfpGroups: Function
    setRemoveOriRfpGroups: (addOriRfpGroups: Function) => void
    selectedRow: SelectedRow
    setSelectedRow: (selectedRow: SelectedRow) => void
    selectedUserStatus: string
    setSelectedUserStatus: (selectedUserStatus: string) => void
    disableAddUser: boolean
    setDisableAddUser: (disableAddUser: boolean) => void
    addNewUserLoading: boolean
    setAddNewUserLoading: (addNewUserLoading: boolean) => void
    removedOriRfp: unknown[]
    setRemovedOriRfp: (removedOriRfp: unknown[]) => void
}

export const useUserManagementStore = create<UserManagementState>((set, get) => ({
    paginationToken: "",
    setPaginationToken: (paginationToken: string) => set({ paginationToken }),
    isActive: true,
    setIsActive: (isActive: boolean) => set({ isActive }),
    addOriRfpGroups: () => { },
    setAddOriRfpGroups: (addOriRfpGroups: Function) => set({ addOriRfpGroups }),
    removeOriRfpGroups: () => { },
    setRemoveOriRfpGroups: (removeOriRfpGroups: Function) => set({ removeOriRfpGroups }),
    selectedRow: {},
    setSelectedRow: (selectedRow: SelectedRow) => set({ selectedRow }),
    selectedUserStatus: "",
    setSelectedUserStatus: (selectedUserStatus: string) => set({ selectedUserStatus }),
    disableAddUser: true,
    setDisableAddUser: (disableAddUser: boolean) => set({ disableAddUser }),
    addNewUserLoading: false,
    setAddNewUserLoading: (addNewUserLoading: boolean) => set({ addNewUserLoading }),
    removedOriRfp: [],
    setRemovedOriRfp: (removedOriRfp: unknown[]) => set({ removedOriRfp })
}))